import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  it: { translation: it },
  es: { translation: es },
};

// Detect crawlers/bots to serve them the French version by default
// Real users keep navigator-based detection (Spanish sees ES, Italian sees IT, etc.)
const isCrawler = typeof navigator !== 'undefined'
  && /bot|crawler|spider|googlebot|bingbot|yandex|baidu|duckduck|slurp|facebookexternalhit|twitterbot|linkedinbot|whatsapp/i
    .test(navigator.userAgent);

const detectionOrder = isCrawler
  ? ['htmlTag']
  : ['localStorage', 'navigator', 'htmlTag'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'it'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: detectionOrder,
      caches: ['localStorage'],
    },
  });

export default i18n;
